import { useCallback } from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { Form, Formik } from 'formik';

// local imports
import { PharmacyService } from 'app/services';
import { useGetPharmacyUserRolesService } from 'app/hooks/services';
import { useStateCallback } from 'app/hooks';
import { EnvDefaults, ValidationSchema } from 'app/utils';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { PharmacyUserForm } from 'app/components/organisms/forms';
import { Breadcrumb } from 'app/components/atoms';

const PharmacyUserAdd = () => {
  const { id } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useStateCallback(false);

  // fetch pharmacy user roles
  const { _service } = useGetPharmacyUserRolesService();
  const pharmacyRoles = _service?.data?.roles;

  // submit form
  const handleSubmit = useCallback(
    async values => {
      setLoading(true, async () => {
        const serviceFn = () => PharmacyService.addPharmacyUser(id, values);
        try {
          await serviceFn();
          setTimeout(() => {
            history.push(`/pharmacy-management/${id}/pharmacy-users-list`);
          }, 2000);
        } catch (err) {
          console.log('Error -> ', err);
        } finally {
          setLoading(false);
        }
      });
    },
    [setLoading, id, history]
  );

  return (
    <>
      <FusePageCarded
        header={<Breadcrumb title="Eczane Kullanıcı Yönetimi" />}
        contentToolbar={
          <Typography variant="h6" className="m-0 p-24 tracking-wider font-semibold text-gray-800">
            Eczane Kullanıcısı Ekle
          </Typography>
        }
        content={
          <div className="p-24">
            <Card elevation={4}>
              <CardContent>
                <Formik
                  enableReinitialize
                  initialValues={EnvDefaults.addEditPharmacyUsersDefaults}
                  validationSchema={ValidationSchema.pharmacyUserCrudSchema(false)}
                  onSubmit={handleSubmit}>
                  <Form>
                    <PharmacyUserForm loading={loading} roles={pharmacyRoles} />
                  </Form>
                </Formik>
              </CardContent>
            </Card>
          </div>
        }
      />
    </>
  );
};

export default PharmacyUserAdd;
